<template>
  <DialogHeader>
    <template #right>
      <div class="font-medium text-green-900 cursor-pointer" @click="close()">
        Close
      </div>
    </template>
    Authors
  </DialogHeader>
  <DialogContent class="flex flex-col overflow-hidden">
    <div class="mb-[14px]">Authors of this registered work</div>

    <Table.Base class="flex flex-col">
      <Table.Headers>
        <Table.Header> Authors </Table.Header>
      </Table.Headers>

      <div class="overflow-y-auto">
        <Table.Row v-for="author in authors" :key="author.id">
          <Table.Cell class="h-10!">
            <Avatar :src="author.avatarUrl" :size="24" class="mr-2.5" />
            <div
              class="font-secondary text-[14px] leading-[18px] text-gray-800"
            >
              {{ author.name }}
            </div>
          </Table.Cell>
        </Table.Row>
      </div>
    </Table.Base>
  </DialogContent>
  <DialogFooter>
    <UiButton class="w-1/2 tablet-h:w-auto" primary @click="close()">
      Close
    </UiButton>
  </DialogFooter>
</template>

<script setup lang="ts">
import { UiButton, Table, Avatar } from '@dacr/ui'
import DialogHeader from '@/shared/dialogs/DialogHeader.vue'
import DialogContent from '@/shared/dialogs/DialogContent.vue'
import DialogFooter from '@/shared/dialogs/DialogFooter.vue'
import { useDialog } from '@/shared/dialogs/useDialog'
import type { File } from '@/shared/graphql/legacy/generated'
import { computed } from 'vue'

const { close } = useDialog()

const props = defineProps<{
  file: File
}>()

const authors = computed(() =>
  props.file.authors.filter((author) => 'id' in author)
)
</script>
